<!-- 创建时间2022/07/01 17:12:12 -->
<!-- 创建人：zhu xiao hu -->
<!-- 组件描述：鉴定-选择模板-抽屉 -->
<template>
  <div>
    <yxt-drawer
      ref="addStuDrawer"
      size="960px"
      :title="$t('pc_biz_appraise_choose_template' /*选择模板*/)"
      :visible.sync="visible"
      :header-border='false'
      destroy-on-close
      :before-close="beforeClose"
      @closed="handleClosed"
    >
      <yxtbiz-survey-template :disabled-create="true" @select="templateSelect" :selected="selected&&selected.id" :type="modeData.type+4" :functionCode="permission.functionCode" :dataPermissionCode="permission.dataPermissionCode"></yxtbiz-survey-template>
      <div slot="footer">
        <yxt-button plain @click="visible = false">{{ $t('pc_biz_utility_btn_cancel') }}</yxt-button>
        <yxt-button type="primary" @click="sureHandle">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
export default {
  name: 'chooseFormworkDrawer',
  data() {
    return {
      visible: false,
      modeData: {type: 1},
      selected: {},
      permission: {
        dataPermissionCode: 'trainScene_itemAppraisal_get_extent',
        functionCode: 'o2o_appraisal_template'
      }
    };
  },
  methods: {
    init(data) {
      console.log(data);
      this.modeData = data;
      if (data.template) {
        this.selected = data.template;
      } else {
        this.selected = undefined;
      }
      this.visible = true;
    },
    beforeClose(done) {
      this.$emit('formWork', this.selected);
      done(this.isChange);
    },
    handleClosed() {
      this.users = [];
      this.isChange = false;
      this.newUsers = [];
      this.selectAllList = [];
      this.selectAllMap = new Map();
      this.selectProjectUsers = [];
    },
    templateSelect(template) {
      this.selected = template;
    },
    sureHandle() {
      this.$emit('formWork', this.selected);
      this.visible = false;
    }
  }
};
</script>

<style scoped>

</style>